<template>
    <div class="outsourcing-person-data-card" :class="{ loading: isLoading }">
        <div class="card-header">
            <!-- <img class="user-icon" src="@/assets/img/user-icon.svg" alt="User Avatar" style="width: 20px;" /> -->
            <div class="header-title">
                <span>{{ loadedData.fnam }}</span>
            </div>
            <div>
                <el-tooltip :manual="isAuth('C03')" effect="light" content="您沒有「請款委外管理」權限" placement="top-end">
                    <el-button v-if="showEditButton" size="mini" icon="el-icon-edit" round :disabled="isLoading || !isAuth('C03') || isQR()" @click="onEditButtnClick">編輯</el-button>
                </el-tooltip>
            </div>
        </div>
        <div class="card-body">
            <div class="data-list">
                <div class="item">
                    <div class="label">國籍</div>
                    <div class="value">
                        <span v-if="loadedData.abd === 0">本國籍</span>
                        <span v-if="loadedData.abd === 1">外國籍，在台已滿183天</span>
                        <span v-if="loadedData.abd === 2">外國籍，在台未滿183天</span>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <div v-if="loadedData.abd === 0">身分證號碼</div>
                        <div v-if="loadedData.abd !== 0 && loadedData.identificationType === 1">護照號碼</div>
                        <div v-if="loadedData.abd !== 0 && loadedData.identificationType === 2">居留證號碼</div>
                    </div>
                    <div class="value">{{ loadedData.bsn }}</div>
                </div>
                <div class="item">
                    <div class="label">投保職業工會</div>
                    <div class="value">
                        <div v-if="loadedData.oS_GRP">
                            <span>有</span>
                            <span>（投保有效日期：{{ loadedData.unionInsuranceExpireDate | dateFormater("YYYY-MM-dd") }} <span v-if="!isUnionInsuranceValid" style="color: red">已過期</span>）</span>
                        </div>
                        <div v-else>無</div>
                    </div>
                </div>
                <div class="item">
                    <div class="label">聯絡電話</div>
                    <div class="value">{{ loadedData.vendorContacts[0].tel || "--" }}</div>
                </div>
                <div class="item">
                    <div class="label">E-mail</div>
                    <div class="value">{{ loadedData.vendorContacts[0].eml || "--" }}</div>
                </div>
                <div class="item">
                    <div class="label">聯絡地址</div>
                    <div class="value">{{ loadedData.adR_CODE }} {{ loadedData.abd === 0 ? loadedData.cty : loadedData.ara }}{{ loadedData.adr || "--" }}</div>
                </div>
                <div class="item">
                    <div class="label">戶籍地址</div>
                    <div class="value">
                        {{ loadedData.permanentAdR_CODE }} {{ loadedData.abd === 0 ? loadedData.permanentAddrCty : loadedData.permanentAddrAra }}{{ loadedData.permanentAddr || "--" }}
                    </div>
                </div>
                <div class="item" style="margin-top: 20px;">
                    <div class="label">證件正反面</div>
                    <div class="value">
                        <div class="idcard-list">
                            <el-image
                                v-if="loadedData.idCardFront"
                                :src="loadedData.idCardFront"
                                :previewSrcList="[loadedData.idCardFront]"
                                class="idcard-img"
                                fit="contain"
                            ></el-image>
                            <el-image
                                v-if="loadedData.idCardBack"
                                :src="loadedData.idCardBack"
                                :previewSrcList="[loadedData.idCardBack]"
                                class="idcard-img"
                                fit="contain"
                            ></el-image>
                            <span v-if="!(loadedData.idCardFront && loadedData.idCardBack)"> -- </span>
                        </div>
                    </div>
                </div>
                <div class="item" v-if="loadedData.oS_GRP">
                    <div class="label">投保工會證明文件</div>
                    <div class="value">
                        <el-image
                            v-if="loadedData.unionInsuranceDoc"
                            :src="loadedData.unionInsuranceDoc"
                            :previewSrcList="[loadedData.unionInsuranceDoc]"
                            style="width: 100px; height: 70px; border: 1px solid #ddd; border-radius: 5px;"
                            fit="contain"
                        ></el-image>
                        <span v-if="!loadedData.unionInsuranceDoc"> -- </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="item">
                <span class="label">最後編輯：</span>
                <span class="value">
                    <span>{{ loadedData.upD_USR }}</span>
                    <span style="margin-left: 10px">{{ loadedData.upD_DAT | dateFormater("YYYY-MM-dd") }}</span>
                </span>
            </div>
        </div>
        <person-upsert-dialog :visible="upsertDialog.visible" :sno="loadedData.sno" @close="onUpsertDialogClose" />
    </div>
</template>
<script>
import moment from 'moment';
import PersonUpsertDialog from '../PersonUpsertDialog/UpsertDialog.vue';

export default {
    name: 'outsourcing-person-data-card',
    components: {
        PersonUpsertDialog,
    },
    props: {
        sno: {
            type: Number,
            default: null,
        },
        showEditButton: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoading: false,

            // 已載入的資料
            loadedData: {
                sno: null,
                vdR_TYP: null, // VD=廠商,OS=勞務
                caT_SNO: null, // 委外類型
                cnam: null, // 簡稱（廠商簡稱）
                fnam: null, // 全名（個人姓名/廠商公司全名）
                abd: null, // 0=國內,1=境外
                abD_TYP: null, // 境外身份：0政府/1公營事業/2民間
                bsn: null, // 證件號碼 / 統編
                bsN_NO: null, // 1=無統編,0=有統編
                bilL_DAY: null, // 結帳日
                soO_DAY: null, // 收款日
                identificationType: null, // 證件類型
                idCardFront: null, // 身分證正面
                idCardBack: null, // 身分證背面
                oS_GRP: null, //  有無職業工會
                unionInsuranceDoc: null, // 職業工會投保證明文件
                unionInsuranceExpireDate: null, // 職業工會投保有效日期
                note: null, // 備註
                permanentAddr: null, // 戶籍地址
                permanentAddrCty: null, // 戶籍地址-縣市
                permanentAddrAra: null, // 戶籍地址-地區（外國籍）
                permanentAdR_CODE: null, // 戶籍地址-郵區碼
                adR_CODE: null, // 郵區碼
                adr: null, // 聯絡地址
                cty: null, // 聯絡地址-城市
                ara: null, // 聯絡地址-地區（外國籍）
                contactAddrAra: null, // contactAddrAra
                vendorContacts: [
                    {
                        tel: null,
                        eml: null,
                    },
                ], // 聯絡資訊
                vendorBanks: [], // 匯款帳戶
            },

            isUnionInsuranceValid: false,

            // 編輯視窗
            upsertDialog: {
                visible: false,
            },
        };
    },
    watch: {
        sno(newVal) {
            console.log('watch sno', newVal);
            // 當 props.sno 改變時，重新載入該委外資料
            this.fetchData(newVal);
        },
    },
    methods: {
        // 載入資料
        async fetchData(sno) {
            if (!sno) return;
            this.isLoading = true;

            try {
                const resp = await this.$api({
                    url: `Outsourcing/GetOutsourcingInfo?sno=${sno}`,
                    method: 'GET',
                });
                console.log(resp.data.item);

                if (resp.data.item) {
                    this.loadedData = resp.data.item;

                    if (this.loadedData.oS_GRP) {
                        const endOfDay = moment().endOf('day');
                        this.isUnionInsuranceValid = moment(this.loadedData.unionInsuranceExpireDate).isAfter(endOfDay);
                    }
                }
            } finally {
                this.isLoading = false;
            }
        },

        // 按下編輯
        onEditButtnClick() {
            this.upsertDialog.visible = true;
        },

        // 編輯視窗關閉
        onUpsertDialogClose(refresh) {
            this.upsertDialog.visible = false;
            if (refresh) this.fetchData(this.sno);
            this.$emit('refresh');
        },
    },
};
</script>
<style lang="scss">
.outsourcing-person-data-card {
    line-height: 150%;
    border: 1px solid #ddd;
    border-radius: 15px;
    // box-shadow: 2px 2px 10px rgba(0,0,0,0.1);
    // max-width: 400px;

    >.card-header {
        display: flex;
        justify-content: space-between;
        padding: 20px 20px;

        @media (min-width: 720px) {
            padding: 30px 30px;
        }

        .header-title {
            font-weight: bold;
            font-size: 15pt;
            padding-top: 3px;
        }
    }

    >.card-body {
        padding: 20px;
        @media (min-width: 720px) {
            padding: 0px 30px 30px 30px;
        }
    }

    >.card-footer {
        // display: none;
        padding: 10px 30px;
        border-top: 1px solid #eee;
        font-size: 8.5pt;
        color: #888;
        // text-align: right;
    }

    .data-list {
        font-size: 10pt;

        >.item {
            display: flex;
            justify-content: space-between;
            align-items: top;
            gap: 25px;
            margin-bottom: 8px;

            @media (min-width: 720px) {
                justify-content: start;
            }

            >.label {
                color: #888;
                flex-shrink: 0;

                @media (min-width: 720px) {
                    width: 110px;
                }
            }

            >.value {
                word-break: break-all;
                @media (min-width: 720px) {

                }
            }
        }
    }

    .idcard-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 5px;

        @media (min-width: 720px) {
            flex-direction: row;
        }

        >.idcard-img {
            width: 90%;
            max-width: 300px;
            aspect-ratio: 5 / 3.2;
            border: 2px solid #ddd;
            border-radius: 10px;
            padding: 5px;
        }
    }
}
</style>
